"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function PositionFromJSON(json) {
    return PositionFromJSONTyped(json, false);
}
exports.PositionFromJSON = PositionFromJSON;
function PositionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'entryValue': !runtime_1.exists(json, 'entryValue') ? undefined : json['entryValue'],
        'currentValue': !runtime_1.exists(json, 'currentValue') ? undefined : json['currentValue'],
        'valueChange': !runtime_1.exists(json, 'valueChange') ? undefined : json['valueChange'],
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'underlyingSymbol': !runtime_1.exists(json, 'underlyingSymbol') ? undefined : json['underlyingSymbol'],
        'expiresAt': !runtime_1.exists(json, 'expiresAt') ? undefined : (json['expiresAt']),
        'openedAt': !runtime_1.exists(json, 'openedAt') ? undefined : (json['openedAt']),
        'closedAt': !runtime_1.exists(json, 'closedAt') ? undefined : (json['closedAt']),
        'target': !runtime_1.exists(json, 'target') ? undefined : _1.TargetFromJSON(json['target']),
        'quantity': !runtime_1.exists(json, 'quantity') ? undefined : json['quantity'],
        'entryPrice': !runtime_1.exists(json, 'entryPrice') ? undefined : json['entryPrice'],
        'currentPrice': !runtime_1.exists(json, 'currentPrice') ? undefined : json['currentPrice'],
        'priceChange': !runtime_1.exists(json, 'priceChange') ? undefined : json['priceChange'],
        'changePercent': !runtime_1.exists(json, 'changePercent') ? undefined : json['changePercent'],
        'valueAtExpiration': !runtime_1.exists(json, 'valueAtExpiration') ? undefined : json['valueAtExpiration'],
        'marketPosition': !runtime_1.exists(json, 'marketPosition') ? undefined : _1.MarketPositionFromJSON(json['marketPosition']),
        'companyName': !runtime_1.exists(json, 'companyName') ? undefined : json['companyName'],
        'title': !runtime_1.exists(json, 'title') ? undefined : json['title'],
        'strategy': !runtime_1.exists(json, 'strategy') ? undefined : _1.StrategyFromJSON(json['strategy']),
        'openOrder': !runtime_1.exists(json, 'openOrder') ? undefined : _1.OrderFromJSON(json['openOrder']),
        'trade': !runtime_1.exists(json, 'trade') ? undefined : _1.TradeFromJSON(json['trade']),
        'executedProfitLoss': !runtime_1.exists(json, 'executedProfitLoss') ? undefined : _1.ProfitLossFromJSON(json['executedProfitLoss']),
        'closeOrders': !runtime_1.exists(json, 'closeOrders') ? undefined : json['closeOrders'],
        'readOnlyAt': !runtime_1.exists(json, 'readOnlyAt') ? undefined : (json['readOnlyAt']),
        'lockedAt': !runtime_1.exists(json, 'lockedAt') ? undefined : (json['lockedAt']),
        'messages': !runtime_1.exists(json, 'messages') ? undefined : (json['messages'].map(_1.PositionMessageFromJSON)),
        'accountNumber': !runtime_1.exists(json, 'accountNumber') ? undefined : json['accountNumber'],
        'premiumLast': !runtime_1.exists(json, 'premiumLast') ? undefined : _1.PremiumFromJSON(json['premiumLast']),
        'premium': !runtime_1.exists(json, 'premium') ? undefined : _1.PremiumFromJSON(json['premium']),
    };
}
exports.PositionFromJSONTyped = PositionFromJSONTyped;
function PositionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'entryValue': value.entryValue,
        'currentValue': value.currentValue,
        'valueChange': value.valueChange,
        'id': value.id,
        'underlyingSymbol': value.underlyingSymbol,
        'expiresAt': value.expiresAt === undefined ? undefined : (value.expiresAt),
        'openedAt': value.openedAt === undefined ? undefined : (value.openedAt),
        'closedAt': value.closedAt === undefined ? undefined : (value.closedAt),
        'target': _1.TargetToJSON(value.target),
        'quantity': value.quantity,
        'entryPrice': value.entryPrice,
        'currentPrice': value.currentPrice,
        'priceChange': value.priceChange,
        'changePercent': value.changePercent,
        'valueAtExpiration': value.valueAtExpiration,
        'marketPosition': _1.MarketPositionToJSON(value.marketPosition),
        'companyName': value.companyName,
        'title': value.title,
        'strategy': _1.StrategyToJSON(value.strategy),
        'openOrder': _1.OrderToJSON(value.openOrder),
        'trade': _1.TradeToJSON(value.trade),
        'executedProfitLoss': _1.ProfitLossToJSON(value.executedProfitLoss),
        'closeOrders': value.closeOrders,
        'readOnlyAt': value.readOnlyAt === undefined ? undefined : (value.readOnlyAt),
        'lockedAt': value.lockedAt === undefined ? undefined : (value.lockedAt),
        'messages': value.messages === undefined ? undefined : (value.messages.map(_1.PositionMessageToJSON)),
        'accountNumber': value.accountNumber,
        'premiumLast': _1.PremiumToJSON(value.premiumLast),
        'premium': _1.PremiumToJSON(value.premium),
    };
}
exports.PositionToJSON = PositionToJSON;
